import React, { useState, useEffect } from 'react'
import BreadCrumbComp from '../../../components/breadCrumb'
import { Grid } from '@mui/material'
import ModalComponent from '../../../components/modals'
import LaddaButton from '../../../components/buttons/laddaButton'
import CustomSnackbar from '../../../components/snackbar'
import { callApiAsync, getSurveyAnswerById } from '../../../services/apiService'
import { toYMD, formatCustomDateNameLocal } from '../../../utils/dateUtils'
import { useParams } from 'react-router-dom'

const ViewSurveyResults = () => {
    const { answerId } = useParams()
    const [loading, setLoading] = useState(false)
    const [surveyData, setSurveyData] = useState(null)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')

    useEffect(() => {
        if (answerId) {
            loadSurveyResults()
        }
    }, [answerId])

    const loadSurveyResults = async () => {
        setLoading(true)
        await callApiAsync(
            () => getSurveyAnswerById(answerId),
            (resp) => {
                const data = resp?.data ?? resp
                setSurveyData(data)
                setLoading(false)
            },
            (error) => {
                setLoading(false)
            }
        )
    }

    if (loading) {
        return (
            <div>
                <BreadCrumbComp />
                <div className="searchTitle">
                    <h1>Cargando resultados...</h1>
                </div>
            </div>
        )
    }

    if (!surveyData) {
        return (
            <div>
                <BreadCrumbComp />
                <div className="searchTitle">
                    <h1>No se encontraron resultados</h1>
                </div>
            </div>
        )
    }

    return (
        <div>
            <BreadCrumbComp />
            <div className="searchTitle">
                <h1>RESULTADOS DE ENCUESTA</h1>
            </div>

            <div className="table-container">
                <div className="mb-20">
                    <div style={{ 
                        border: '2px solid #6C5CE7', 
                        borderRadius: '8px', 
                        padding: '20px', 
                        marginBottom: '30px',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <h2 className="title-bio-details-chard" style={{ 
                            marginBottom: '15px', 
                            color: '#6C5CE7',
                            fontSize: '18px'
                        }}>
                            Resultados de tu Encuesta
                        </h2>
                        {surveyData.userName && (
                            <p className="detail-label" style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>
                                Usuario: <strong>{surveyData.userName}</strong>
                            </p>
                        )}
                        {surveyData.orderNumber && (
                            <p className="detail-label" style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>
                                Número de Orden: <strong>{surveyData.orderNumber}</strong>
                            </p>
                        )}
                        {surveyData.responseDate && (
                            <p className="detail-label" style={{ fontSize: '14px', color: '#666' }}>
                                Fecha de Respuesta: <strong>{formatCustomDateNameLocal(toYMD(surveyData.responseDate))}</strong>
                            </p>
                        )}
                    </div>

                    <Grid container spacing={3}>
                        {surveyData.questionsWithAnswers && surveyData.questionsWithAnswers.map((item) => (
                            <Grid item xs={12} key={item.questionNumber}>
                                <div className="mb-20" style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    backgroundColor: '#fff'
                                }}>
                                    <p className="select-form-label" style={{ 
                                        color: '#6C5CE7', 
                                        fontWeight: 'bold',
                                        marginBottom: '10px',
                                        fontSize: '16px'
                                    }}>
                                        Pregunta {item.questionNumber}
                                    </p>
                                    <p className="detail-label" style={{ 
                                        marginBottom: '15px', 
                                        fontSize: '14px',
                                        color: '#333'
                                    }}>
                                        {item.questionText}
                                    </p>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '10px',
                                        backgroundColor: '#f0f0f0',
                                        borderRadius: '5px'
                                    }}>
                                        <span style={{ fontWeight: 'bold', color: '#6C5CE7' }}>
                                            Tu respuesta:
                                        </span>
                                        <span style={{ 
                                            fontSize: '18px', 
                                            fontWeight: 'bold',
                                            color: '#333'
                                        }}>
                                            {item.answer}/10
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </div>
    )
}

export default ViewSurveyResults
